import { BaseModel } from './base-model';
import { MarketLevel } from './market-level';
import { Organization } from './organization';

export class Market extends BaseModel {
    MarketCode: string;
    MarketName: string;
    Organization?: Organization;
    MarketLevel: MarketLevel;
    Parent?: Market;
    ParentMarketList: Market[];
    Weekends?: any;
    ShiftStartTime?: string;
    ShiftEndTime?: string;
    MarketRank?: number;
    marketLevel?: MarketLevel;

    Name?: string;
    Code?: string;
    name?: string;
    code?: string;
    constructor( pId?: number ) {
        super();
        if ( pId ) {
            this.Id = pId;
        }
    }
}
